export default class MeetingRequestDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ meetingRequestStatusDate: Date; }' is missing the following properties from type 'MeetingRequest': id, primary, serviceDeliveryLocationName, createdDate, and 8 more.
        return Object.assign(Object.assign({}, json), { meetingRequestStatusDate: new Date(parseInt(json.meetingRequestStatusDate, 10)) });
    }
}
